import React, { useState } from 'react';
import { formatCPF } from '../../utils/cpfUtils';

/**
 * Seleciona uma pessoa já cadastrada (módulo Pessoas) para importar
 * seus dados no cadastro de diretores.
 */
function PessoaPicker({ show, pessoas = [], onSelect, onClose }) {
  const [search, setSearch] = useState('');

  if (!show) return null;

  const normalize = s =>
    (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  const termo = normalize(search);
  const digitos = search.replace(/\D/g, '');

  const filtered = pessoas
    .filter(
      p =>
        normalize(p.nome).includes(termo) ||
        (digitos && (p.cpf || '').includes(digitos))
    )
    .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));

  function handleSelect(p) {
    onSelect(p);
    setSearch('');
  }

  function handleClose() {
    setSearch('');
    onClose();
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 1065,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        className="modal-content"
        style={{
          width: '90%',
          maxWidth: 640,
          height: 500,
          minHeight: 500,
          maxHeight: 500,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 6,
          overflow: 'hidden',
          backgroundColor: '#fff',
        }}
      >
        {/* Header */}
        <div
          className="modal-header bg-success text-white"
          style={{ padding: '0.35rem 1rem' }}
        >
          <h6 className="modal-title mb-0 small">
            <i className="bi bi-people me-2"></i>IMPORTAR DE PESSOAS
          </h6>
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={handleClose}
          />
        </div>

        {/* Body */}
        <div
          className="modal-body"
          style={{
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            padding: '1rem',
          }}
        >
          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">
              <i className="bi bi-search me-1"></i>BUSCAR
            </label>
            <input
              autoFocus
              type="text"
              className="form-control form-control-sm"
              placeholder="Buscar por nome ou CPF..."
              value={search}
              onChange={e => setSearch(e.target.value.toUpperCase())}
            />
          </div>

          <div className="border rounded" style={{ overflowY: 'auto', flex: 1 }}>
            <table className="table table-hover table-sm mb-0">
              <thead className="table-light">
                <tr>
                  <th className="small">Nome</th>
                  <th className="small">CPF</th>
                  <th className="small d-none d-sm-table-cell">Cidade / UF</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(p => (
                  <tr
                    key={p.cpf}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSelect(p)}
                  >
                    <td className="small">{p.nome}</td>
                    <td className="small">{formatCPF(p.cpf)}</td>
                    <td className="small d-none d-sm-table-cell">
                      {p.logrCidade}
                      {p.logrUf ? ` / ${p.logrUf}` : ''}
                    </td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan={3} className="text-center text-muted small py-3">
                      <i className="bi bi-inbox me-2"></i>Nenhuma pessoa encontrada.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer" style={{ padding: '0.4rem 1rem' }}>
          <span className="text-muted small me-auto">
            {filtered.length} registro
            {filtered.length !== 1 ? 's' : ''} encontrado
            {filtered.length !== 1 ? 's' : ''}
          </span>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={handleClose}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default PessoaPicker;
